import type { AgentStats } from "../types/user";

/** Every canonical status contributes to the same scoped application total. */
export function applicationStatusBreakdown(stats: AgentStats) {
  const total = stats.totalApplications || 1;
  const buckets: [string, string, keyof AgentStats, string][] = [
    ["APPROVED", "Approved", "approvedApplications", "#059669"],
    ["SUBMITTED", "Submitted", "submittedApplications", "#3b82f6"],
    [
      "VISA_APPLICATION",
      "Visa Application",
      "visaApplicationApplications",
      "#0891b2",
    ],
    ["DRAFT", "Draft", "draftApplications", "#6b7280"],
    ["REJECTED", "Rejected", "rejectedApplications", "#dc2626"],
    ["DEFERRED", "Deferred", "deferredApplications", "#8b5cf6"],
    ["WITHDRAWN", "Withdrawn", "withdrawnApplications", "#9ca3af"],
    [
      "TUITION_PAYMENT_STAGE",
      "Tuition Payment",
      "tuitionPaymentStageApplications",
      "#f97316",
    ],
    ["PAID", "Paid", "paidApplications", "#10b981"],
    ["VISA_APPROVED", "Visa Approved", "visaApprovedApplications", "#0d9488"],
    ["ENROLLED", "Enrolled", "enrolledApplications", "#166534"],
  ];
  return buckets
    .map(([status, name, field, color]) => {
      const value = Number(stats[field]) || 0;
      return {
        status,
        name,
        value,
        percentage: Math.round((value / total) * 100),
        color,
      };
    })
    .filter((item) => item.value > 0);
}
